module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-16b.cc98a7f2.jpg";